import React from 'react';
import RoundupRow from './RoundUpRow';
import { flex, alignItemsBaseline } from 'scy/flex.mod.scss';
import { AccentRadioButton } from 'scy/RadioButton';
import { capitalize } from 'shared/utils';
import { H4, Body } from 'scy/text';
import padding from 'scy/padding.mod.scss';
import classnames from 'classnames';
import styles from './style.mod.scss';
const Organizations = ({
  showOrgs,
  orgs,
  submitNewRoundUpOrganization,
  roundUpOrgID
}) => {
  return orgs.map(org => (
    <div
      key={`org_${org.name}`}
      onClick={() => submitNewRoundUpOrganization(org.id)}
    >
      <RoundupRow
        showOrgs={showOrgs}
        className={classnames(flex, alignItemsBaseline)}
      >
        <AccentRadioButton
          checked={org.id === roundUpOrgID}
          ariaLabel={org.name}
          ariaLabelText={org.name}
        />
        {/* <img src={org.logo_url} /> */}
        <div>
          <H4 className={padding.bottom_xs}>{capitalize(org.name)}</H4>
          <Body
            className={classnames(
              styles.line_clamp_5,
              org.id === roundUpOrgID && styles.no_line_clamp
            )}
          >
            {org.mission}
          </Body>
        </div>
      </RoundupRow>
    </div>
  ));
};

export default Organizations;
